export const getTokenStoreId = (store) => {
  if (typeof store.storeId === 'object') return store.storeId._id
  else if (typeof store.storeId === 'string') return store.storeId
}